import LoginComponent from "./login";
import { useDispatch } from "react-redux";
import { useState, useContext } from "react";
import * as admin from "@/views/admin-dashboard/admin.slice";
import UserPool from "./user-pool";
import { AccountContext } from "./account";

function Login() {
  const dispatch = useDispatch();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);
  const { authenticate } = useContext(AccountContext);

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const handleLoginClik = () => {
    setLoggingIn(true);
    authenticate(username, password)
      .then(() => {
        setLoggingIn(false);
        dispatch(admin.setStatusLogin({ status: admin.StatusLogin.LOGGED_IN }));
      })
      .catch(() => {
        setLoggingIn(false);
        dispatch(admin.setStatusLogin({ status: admin.StatusLogin.FAILED }));
      });
  };
  const handleShowPasswordClick = () => {
    setShowPassword(!showPassword);
  };

  const handleSignUpClick = () => {
    UserPool.signUp(username, password, [], null, (err) => {
      console.error(err);
    });
  };
  return (
    <LoginComponent
      onLoginClick={handleLoginClik}
      onUsernameChange={handleUsernameChange}
      onPasswordChange={handlePasswordChange}
      onShowPasswordClick={handleShowPasswordClick}
      onSignUpClick={handleSignUpClick}
      username={username}
      password={password}
      showPassword={showPassword}
      loggingIn={loggingIn}
    />
  );
}
export default Login;
